import { range, ScaleLinear, tickStep } from "d3"

export const getTickYCorrection = (index: number, ticks: ArrayLike<any>) => {
    // Give the first and last ticks a little push to keep them inside the graph y bounds instead of centered on the tick marks.
	const pushAmount = 3

    if (index === 0) {
        return -pushAmount
    }
    
    if (index === ticks.length-1) {
        return pushAmount
    }

    return 0
}

export const getNiceTicks = (scale: ScaleLinear<any, any, any>): number[] => {
		const height = scale.range()[0]
		const [min, max] = scale.domain()

		let desiredTickCount = 4

		if (height < 30) {
			return [min, max]
		}

		if (height < 60) {
			return [min, (min + max)/2, max]
		}

		if (height < 100) {
			desiredTickCount = 3
		}

		const step = tickStep(min, max, desiredTickCount)
		const margin = 15 // pixels
		const valueMargin = Math.abs(scale.invert(margin) - scale.invert(0))

		const rawTicks = range(
			Math.floor(min / step) * step,
			Math.ceil(max / step) * step + step / 2,
			step
		)

		const ticks: number[] = []

		for (const t of rawTicks) {
			const inRange = t >= min && t <= max
			const tooCloseToMin = Math.abs(t - min) < valueMargin
			const tooCloseToMax = Math.abs(t - max) < valueMargin

			if (inRange && !tooCloseToMin && !tooCloseToMax) {
				ticks.push(+t.toFixed(10)) // Avoid float artifacts
			}
		}

		if (ticks.length === 1) {
			ticks[0] = (max+min)/2
		} 

		return [min, ...ticks, max]
	}
